const LEARNING_LEVEL_OPTIONS = [
   {
      value: 'Org',
      label: 'Organization',
   },
   {
      value: 'Adv',
      label: 'Hiring Company',
   },
   {
      value: 'Hybrid',
      label: 'Hybrid',
   },
];

export default LEARNING_LEVEL_OPTIONS;
